export default __webpack_public_path__ + "static/media/GH.0daab75a.svg";